var $ = require('jquery')

$(function () {
  $('.clear-form').on('click', function () {
    $(this.form).find('select').val('').end().find(':checked').prop('checked', false)
    $('.select-cities > option').remove()
    $('.select-cities').append(
      $('<option>').html('指定なし').val(null)
    )
  })
})
